import SocialShareHeader from './SocialShareHeader';

export default SocialShareHeader;
